import moment from 'moment';

export const LazyLoader = (props: any) => {
  return (
    <>
      <div className="loading-wrapper">LOADING</div>
    </>
  );
};

export const validateEmail = (email: string) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const phoneNumberMask = '###-###-####';

export const formatPhoneNumber = (phoneNumberString: string) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return match[1] + '-' + match[2] + '-' + match[3];
  }
  return null;
};

export const convertStringToTime = (time: string) => {
  const today = new Date().toISOString();
  const nowDate = today.split('T')[0];
  const target = new Date(nowDate + 'T' + time);
  return moment(target.getTime()).format('LT');
};

export const formatDate = (isoDate: string, dateOnly = false): string => {
  const date = new Date(isoDate);

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 -> 12

  return dateOnly
    ? `${month}/${day}/${year}`
    : `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
};

export const addModalOpenClass = () => {
  const html = document.documentElement;
  html.classList.add('modal-open');
};

export const removeModalOpenClass = () => {
  const html = document.documentElement;
  html.classList.remove('modal-open');
};

export const ORDER_STATUS = {
  PAID: 'PAID',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  PARTIALLY_PAID: 'PARTIALLY PAID',
  REFUNDED: 'REFUNDED',
};

export const ORDER_STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'PAID', label: 'Paid' },
  { value: 'FAILED', label: 'Failed' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'PARTIALLY_PAID', label: 'Partially Paid' },
  { value: 'REFUNDED', label: 'Refunded' },
];

export const TRANSACTIONS_STATUS = {
  pending: 'PENDING',
  succeeded: 'SUCCEEDED',
  failed: 'FAILED',
  cancelled: 'CANCELLED',
  refunded: 'REFUNDED',
  partially_refunded: 'PARTIALLY REFUNDED',
};

export const TRANSACTIONS_STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'succeeded', label: 'Succeeded' },
  { value: 'pending', label: 'Pending' },
  { value: 'failed', label: 'Failed' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'refunded', label: 'Refunded' },
  { value: 'partially_refunded', label: 'Partially Refunded' },
];

export const CHECK_STATUS = {
  PENDING: 'PENDING',
  PAID: 'PAID',
  FAILED: 'FAILED',
  INPROGRESS: 'IN PROGRESS',
  EMAIL_SENT: 'EMAIL SENT',
  EMAIL_IN_PROGRESS: 'EMAIL IN PROGRESS',
  EMAIL_FAILED: 'EMAIL FAILED',
  REFUNDED: 'REFUNDED',
};

export const TRANSACTIONS_TYPE = {
  cash: 'CASH',
  card: 'CARD',
  stripe_checkout: 'STRIPE CHECKOUT',
  refund: 'REFUND',
};
